<script>
import variables from '@/config/styles/variables.scss'
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    style: {
      type: String,
      default: 'font-size: ' + variables.menuFontSize
    }
  },
  render(h, context) {
    const { icon, title, style } = context.props
    const vnodes = []

    if (icon) {
      // vnodes.push(<svg-Icon Icon-class={Icon} style={style}/>)
      vnodes.push(<span nav-icon={icon} style={style}/>)
    }

    if (title) {
      vnodes.push(<span slot='title' style={style}>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
